export const sourceOptions = ['transport', 'opération', 'commerciale', 'client', 'copima'];

export const anomaliesOptions = {
  transport: ['Colis perdu', 'Colis endommagé'],
  opération: ['Erreur ville', 'Référence en plus', 'Manque de référence', 'Erreur transport', 'Erreur référence', 'Erreur retour de fond', 'Problème valeur déclaré', 'Erreur quantité'],
  commerciale: ['Erreur client', 'Erreur transport', 'Erreur quantité', 'Erreur référence', 'Changement de marque demandé', 'Erreur comptant au lieu de compte E/C'],
  client: ['Défectueux', 'Erreur client référence/quantité'],
  copima: ['Changement de remise', 'Erreur remise', 'Manque de cachet', 'Article usé', 'Client litigieux', 'Hors garantie'],
};
